import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ReportingUiModule } from '@ot/reporting/ui';
import { SharedQuestionsModule } from '@ot/shared/questions';
import { SidePanelModule } from '@ot/shared/utils';
import { FilterBuilderComponent } from './filter-builder/filter-builder.component';

@NgModule({
  declarations: [FilterBuilderComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ReportingUiModule,
    SharedQuestionsModule,
    SidePanelModule
  ],
  exports: [FilterBuilderComponent]
})
export class FilterBuilderModule {}
